// extracted by mini-css-extract-plugin
export var table = "_xb-0";